class AddSampleButton {
  constructor() {
    this.init();
  }

  init() {
    // Use event delegation to handle dynamically added buttons
    document.addEventListener('click', this.handleClick.bind(this));
    console.log('hello world');
  }

  handleClick(event) {
    const button = event.target.closest('.btn__add-sample');
    if (!button) return;

    event.preventDefault();
    this.addSampleToCart(button);
  }

  async addSampleToCart(button) {
    const variantId = button.dataset.variantId;
    const productTitle = button.dataset.productTitle;
    
    if (!variantId) {
      console.error('No variant ID found');
      return;
    }

    // Prevent multiple clicks
    if (button.disabled) return;

    // Set loading state
    this.setButtonState(button, 'loading', 'Loading');

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId), quantity: 1 }],
        }),
      });

      const data = await response.json();

      if (response.ok) {
        // Success feedback
        this.setButtonState(button, 'success', 'Added');
        
        // Dispatch custom event for cart updates
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { items: data.items }
        }));
        
        // Reset button after delay
        setTimeout(() => {
          this.resetButton(button);
        }, 2000);
      } else {
        throw new Error(data.message || 'Failed to add to cart');
      }
    } catch (error) {
      console.error('Error adding sample to cart:', error);
      
      // Error feedback
      this.setButtonState(button, 'error', 'Error');
      
      // Reset button after delay
      setTimeout(() => {
        this.resetButton(button);
      }, 2000);
    }
  }

  setButtonState(button, state, text) {
    button.disabled = true;
    button.textContent = text;
    
    // Remove all state classes
    button.classList.remove('loading', 'success', 'error');
    
    // Add current state class
    if (state !== 'default') {
      button.classList.add(state);
    }
  }

  resetButton(button) {
    button.disabled = false;
    button.textContent = 'Add Sample';
    button.classList.remove('loading', 'success', 'error');
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new AddSampleButton();
  });
} else {
  new AddSampleButton();
}
